import {Pipe, PipeTransform} from '@angular/core';
import {PalletType} from "@services";

@Pipe({
    name: 'palletType',
    standalone: true
})
export class PalletTypePipe implements PipeTransform {
    transform(value: PalletType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case PalletType.NA: return "N/A";
            default: return value;
        }
    }
}
